// frontend/src/pages/AuthCallback.jsx
import { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// tiny helper; you can use qs, query-string, or URLSearchParams
const getTokenFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return params.get('token');
};

function AuthCallback() {
  const { login }   = useContext(AuthContext);
  const navigate     = useNavigate();
  const location     = useLocation();

  useEffect(() => {
    const token = getTokenFromSearch(location.search);

    if (token) {
      login(token);            // ① stash it in context / localStorage
      navigate('/profile');    // ② go somewhere meaningful
    } else {
      // Something’s wrong – punt them to the login screen
      navigate('/login');
    }
  }, [location.search, login, navigate]);

  return <p className="text-center mt-40">Signing you in…</p>;
}

export default AuthCallback;
